import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { makeObservable } from 'mobx'
import i18n from 'i18next'

import Anchor from '../../UniformComponents/Anchor'
import Badge from '../../UniformComponents/Badge'

import './newHeader.scss'

const TRUNCATE_SHORT = 20
const TRUNCATE_LONG = 40
const pathsToTruncate = new Set(['productTitle', 'surveyTitle'])

@observer
class NewHeader extends Component {
    constructor(props) {
        super(props)
        makeObservable(this)
    }

    truncate = (str, length, name) => {
        if (!str) return ''
        if (pathsToTruncate.has(name) && str.length > length) return str.slice(0, length).concat('...')
        return str
    }

    renderBreadcrumb = () => {
        const { store } = this.props
        const breadcrumbsCopy = [...store.breadcrumps]
        const clientName = store.userData?.clientName || i18n.t('home')
        const isHome = breadcrumbsCopy.length < 1
        const isClientTruncated = clientName.length > (isHome ? TRUNCATE_LONG : TRUNCATE_SHORT)

        return !store.isLoginChoose && (
            <ul>
                <li>
                    <Anchor href="/" title={isClientTruncated ? clientName : null}>
                        {isHome
                            ? this.truncate(clientName, TRUNCATE_LONG)
                            : this.truncate(clientName, TRUNCATE_SHORT)}
                    </Anchor>
                </li>
                {breadcrumbsCopy.map((path, ind) => {
                    const text = this.truncate(path.title, ind === breadcrumbsCopy.length - 1 ? TRUNCATE_LONG : TRUNCATE_SHORT, path.name)
                    return (
                        <>
                            <i className="fas fa-chevron-right" />
                            <li style={{
                                minWidth: !pathsToTruncate.has(path.name) ? 'auto' : '8px',
                                display: path.branching ? 'flex' : undefined,
                            }}
                            >
                                <Anchor
                                    href={path.url}
                                    title={pathsToTruncate.has(path.name) && path.title
                                    && path.title.length > TRUNCATE_SHORT ? path.title : null}
                                    cssClass={!pathsToTruncate.has(path.name) ? 'no-ellipsis' : ''}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {path.name === 'surveyTitle' && process.env.SURVEY_STATE_REBRAND_2026 && (
                                            <i className={`fa-${store.surveyStatus === 'development' ? 'regular' : 'solid'} fa-circle tab-status-icon tab-status-icon--${store.surveyStatus}`} aria-hidden="true" />
                                        )}

                                        {path.branching
                                            ? (
                                                <span style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
                                                    <Badge
                                                        type="archive"
                                                        cssClass="status-badge branchBreadcrumb"
                                                        icon="fa-sharp fa-thin fa-sitemap"
                                                        isRounded
                                                    >
                                                        <span style={{ marginLeft: '8px' }}>
                                                            {path.isParent
                                                                ? i18n.t('surveyBuilder.branchingBanner.badge1')
                                                                : i18n.t('surveyBuilder.branchingBanner.badge2')}
                                                        </span>
                                                    </Badge>
                                                </span>
                                            )
                                            : null}

                                        {store.survey?.metadata?.isRapidSurvey && path.name === 'surveyTitle' ? (
                                            <span style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
                                                <Badge
                                                    type="archive"
                                                    cssClass="status-badge liteBreadcrumb"
                                                    icon="fa-sharp fa-thin fa-feather"
                                                    isRounded
                                                >
                                                    <span style={{ marginLeft: '8px' }}>
                                                        {i18n.t('surveyBuilder.rapidSurvey.badge.title')}
                                                    </span>
                                                </Badge>
                                            </span>
                                        ) : null}

                                        <span style={{ marginLeft: path.name === 'surveyTitle' && process.env.SURVEY_STATE_REBRAND_2026 ? '8px' : '' }}>{text}</span>
                                    </div>
                                </Anchor>
                            </li>
                        </>
                    )
                })}
            </ul>
        )
    }

    render() {
        const { store } = this.props
        const removeLeftPad = store.loggedIn
            && store.tokenLoaded
            && store.isLoginChoose
        return (
            <div className={`header-wrapper ${removeLeftPad ? 'header-wrapper-left' : ''}`}>
                <div id="main-header">
                    <div id="breadcrumb">
                        {this.renderBreadcrumb()}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            gap: '15px',
                        }}
                    >
                        {(window.location.pathname.includes('/intranet') && store.isExploriAdmin())
                            ? (
                                <div style={{ margin: 'auto', display: 'flex' }}>
                                    <span>
                                        <a href="/intranet/loggedInUsers" className="users">
                                            {`No. of logged-in users: ${store.numberOfLoggedinUsers}`}
                                        </a>
                                    </span>
                                </div>
                            ) : null}
                        <div id="logo">
                            <a href="/">
                                <img src={`${process.env.CDN_URL}/images/logo_explori.png`} alt="Explori Logo" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewHeader
